export default __webpack_public_path__ + "static/multimodal-input-d5dbe18c173bb6d66bc532e10eb7aee7.png";